import { render, staticRenderFns } from "./Regional_analysis_Materials_Left.vue?vue&type=template&id=7c139fba&scoped=true"
import script from "./Regional_analysis_Materials_Left.vue?vue&type=script&lang=js"
export * from "./Regional_analysis_Materials_Left.vue?vue&type=script&lang=js"
import style0 from "./Regional_analysis_Materials_Left.vue?vue&type=style&index=0&id=7c139fba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c139fba",
  null
  
)

export default component.exports